const { REACT_APP_SUBSCRIPTION_AUDIENCE } = process.env;
export const RESENT_EMAIL_COUNTDOWN = 60; // this value is in seconds
export const FORGOT_PASSWORD_COUNTDOWN = 60; //this value is in seconds
export const LOGIN_PAGE_REDIRECTOR_COUNTDOWN = 10; //this value is in seconds
export const relNoopener = "noopener";
export const targetblank = "_blank";
export const themesColorData = [
  { name: "Royal Indigo", baseColor: "#2A007C", activeColor: "#0c005e", lightColor: "#F4EEFF" },
  { name: "Crimson",      baseColor: "#7C0700", activeColor: "#590803", lightColor: "#FFE9E8" },
  { name: "Magenta",      baseColor: "#7C0052", activeColor: "#630443", lightColor: "#FFE4F6" },
  { name: "Teal",         baseColor: "#007C66", activeColor: "#364f37", lightColor: "#ECFFFC" },
  { name: "Copper",       baseColor: "#8E4E1C", activeColor: "#633612", lightColor: "#FFECE0" },
  { name: "Forest",       baseColor: "#006704", activeColor: "#024d04", lightColor: "#D9EEDA" },
  { name: "Olive",        baseColor: "#525400", activeColor: "#393b01", lightColor: "#EAEBD1" },
  { name: "Ocean",        baseColor: "#00546E", activeColor: "#01485e", lightColor: "#E7F9FF" },
  { name: "Plum",         baseColor: "#3E2057", activeColor: "#301745", lightColor: "#EDDCFB" },
];

export const initThemeColor = {
  PRIMARY: "#2A007C",
  PRIMARY_DARK: "#0c005e",
  PRIMARY_LIGHT: "#F4EEFF",
};

export const authorizationParams = {
  audience: REACT_APP_SUBSCRIPTION_AUDIENCE ?? "",
  scope: "openid offline_access",
};

export const allUsersStatus = "A,P,D,I";
export const userStatusFilterOptions = [
  { label: "All", value: allUsersStatus },
  { label: "Active", value: "A" },
  { label: "Inactive", value: "P,I" },
  { label: "Deleted", value: "D" },
];

export const status = {
  pending: "Pending",
  active: "Active",
  inactive: "Inactive",
  deleted: "Deleted",
  invited: "Invited",
};

export const comingSoonProducts: string[] = [""];

export const haveToDisplayPricingDropdown = true;
